import { render, staticRenderFns } from "./CyberboardGlacierR2.vue?vue&type=template&id=283a4c1a&scoped=true"
import script from "./CyberboardGlacierR2.vue?vue&type=script&lang=ts"
export * from "./CyberboardGlacierR2.vue?vue&type=script&lang=ts"
import style0 from "./CyberboardGlacierR2.vue?vue&type=style&index=0&id=283a4c1a&prod&lang=scss&scoped=true"
import style1 from "./CyberboardGlacierR2.vue?vue&type=style&index=1&id=283a4c1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283a4c1a",
  null
  
)

export default component.exports